const API_URL = {
  //auth
  login: "login",
  authentication: "two-factor-verification",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
  refreshToken: "refresh-token",
  logout: "logout",
  changePassword: "change-password-for-first-time",

  //health organisation
  getHealthOrgList: "health-organisation/list",
  getHealthOrgDetails: "health-organisation/id",
  addHealthOrg: "health-organisation/create",
  updateHealthOrgDetails: "health-organisation/update",

  //user
  getUsers: "user/list",
  getProfileDetails: "profile",
  updateUsersStatus: "users/update-status",
  user: "user",
  updateUserDetails: "user/update",

  //laboratory
  getLaboratoryList: "laboratory/list",
  getLaboratoryDetails: "laboratory/id",
  addLaboratory: "laboratory/create",
  updateLaboratoryDetails: "laboratory/update",

  //user roles
  userRoles: "user-role/list",
  userRole: "user-role",
  updateUserRoleStatus: "user-roles/update-status",

  //user group
  userGroups: "user-group-type",

  //user type
  userType: "user-type",

  //create user admin / doctor / nurse
  createUserAdmin: "user/create",

  //register nurse
  registerNurse: "nurse-profile",

  //surgeons
  getSurgeons: "doctor/list",
  surgeon: "doctor/id",
  updateSurgeonStatus: "doctors/update-status",
  addSurgeon: "doctor/create",
  updateDoctor: "doctor/update",
  updateSurgeonDefaultAddress: "update/default_address",
  addDoctorToHealthOrg: "create/doctor_health_org",
  removeDoctorFromHealthOrg: "update/doctor_health_org",

  //specialities
  getSpecialities: "specialities?is_active=true&limit=100&offset=0",

  //patient specimen records
  getPatientSpecimenRecords: "patient-specimen-records",
  getPatientRequestForm: "request-form/get",
  getPatientRequestFormDetails: "patient-request-form",

  //operating theatre
  getOperatingTheatres: "specimen-room/list",
  updateOperatingTheatreStatus: "specimen-rooms/update-status",
  operatingTheatre: "specimen-room/id",
  addOperatingTheatre: "specimen-room/create",
  updateOperatingTheatre: "specimen-room/update",

  //notes type
  getNotesTypeList: "notes-type/list",

  //extract-data
  extractData: "ocr/extract_details",

  //delete saved cookies
  deleteCookies: "cookies/delete-cookies",

  //set cookies
  setCookies: "cookies/set-cookies",

  //speciality
  getSpecialityList: "speciality/list",
  getSpecialityDetails: "speciality/id",
  addSpeciality: "speciality/create",
  updateSpecialityDetails: "speciality/update",

  //clinical diagram
  getClinicalDiagramList: "clinical-diagram/list",

  //test types
  getTestTypeList: "test-type/list",
  getTestTypeDetails: "test-type/id",
  addTestType: "test-type/create",
  updateTestTypeDetails: "test-type/update",

  //organs
  organ: "speciality/organ",

  //sites
  site: "speciality/site",

  //lesions
  lesion: "speciality/lesion",

  //metadata
  metadata: "speciality/metadata",

  //procedures
  getProceduresList: "procedure/list",
  getProcedureDetails: "procedure/id",
  addProcedure: "procedure/create",
  updateProcedureDetails: "procedure/update",

  //clinical diagrams
  getClinicalDiagrams: "clinical-diagram/list",
  getClinicalDiagramDetails: "clinical-diagram/id",
  addClinicalDiagram: "clinical-diagram/create",
  updateClinicalDiagramDetails: "clinical-diagram/update",

  //s3 object
  getS3Object: "reference-data/fetch-s3-object",
  doctorBase: "doctor",

  //pathology register
  getPathologyRegisterPatientSpecimenRecords: "pathology-register",

  //reference data
  getReferenceData: "reference-data/get-data",

  //api services
  getAPIServiceList: "api-service/list-api-services",
  getRoleAPIServiceList: "api-service/roles-with-api-services",
  updateUserRoleDetails: "api-service/map-api-services",

  //specimen audit / tracking
  getSpecimenAuditEvents: "specimen-audit/events",
  getSpecimenAuditAnalytics: "specimen-audit/analytics",
};

export { API_URL };
